import {log, merge, pipe, tap} from '@yandex-delivery/utils'
import type {Order as FormValues} from 'src/shared/types'

export function withZonePoint(zonePoint: [number, number]) {
  const partialValues = {
    sourcePoint: {
      address: {
        coordinates: zonePoint,
      },
    },
  }

  return function _withZonePoint(values: FormValues): FormValues {
    return pipe(
      partialValues,
      tap(log('Стейт адреса в урле')),
      merge(values),
      tap(log('Стейт формы после мерджа с урлом')),
    )
  }
}
